<template>
  <q-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">
    <q-card style="width: 700px; max-width: 90vw;">
      <q-card-section class="row items-center q-pb-none">
        <div class="text-h6">Add Existing Switchboard to Electrical Tree</div>
        <q-space />
        <q-btn icon="close" flat round dense @click="$emit('update:modelValue', false)" />
      </q-card-section>

      <q-card-section>
        <div class="text-body2 text-grey-7 q-mb-md">
          Select an existing switchboard from the hierarchy to add to the electrical tree and create electrical relationships.
        </div>

        <q-select
          :model-value="selectedSwitchboard"
          :options="availableSwitchboards"
          option-value="id"
          option-label="name"
          label="Switchboard"
          outlined
          emit-value
          map-options
          class="q-mb-md"
          @update:model-value="$emit('update:selected', $event)"
        >
          <template #option="scope">
            <q-item v-bind="scope.itemProps">
              <q-item-section avatar>
                <q-icon :name="scope.opt.icon" :color="scope.opt.color" />
              </q-item-section>
              <q-item-section>
                <q-item-label>{{ scope.opt.name }}</q-item-label>
                <q-item-label caption>
                  {{ scope.opt.type }}
                  <span v-if="scope.opt.space"> - {{ scope.opt.space }}</span>
                </q-item-label>
              </q-item-section>
            </q-item>
          </template>
        </q-select>

        <div v-if="availableSwitchboards.length === 0" class="text-center text-grey-6 q-pa-md">
          No compatible switchboards available. Create switchboards in the Hierarchy tab first.
        </div>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="Cancel" @click="$emit('update:modelValue', false)" />
        <q-btn
          color="primary"
          label="Add to Electrical Tree"
          :disable="!selectedSwitchboard"
          @click="$emit('submit')"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup>
  import { defineProps, defineEmits } from 'vue';

  const props = defineProps({
    modelValue: { type: Boolean, required: true },
    selectedSwitchboard: { type: Number, default: null },
    availableSwitchboards: { type: Array, required: true },
  });

  const emit = defineEmits(['update:modelValue', 'update:selected', 'submit']);
</script>
